const SvgTwitter: React.FC<{ className?: string, height?: number, width?: number }> = ({ className, height, width }) => (
 <svg
xmlns="http://www.w3.org/2000/svg" 
className={`h-6 w-6 ${className} text-black `}
viewBox="0 0 24 24"
width={width}
height={height}
fill="currentColor"
stroke="none"
strokeWidth={1}

>

  <path d="m18.9,1.153h3.682l-8.042,9.189,9.46,12.506h-7.405l-5.804-7.583-6.634,7.583H.469l8.6-9.831L0,1.153h7.593l5.241,6.931,6.065-6.931Zm-1.293,19.494h2.039L6.482,3.239h-2.19l13.314,17.408Z"/>

</svg>
  );
  
  export default SvgTwitter;
